import { render } from "./discussion-modal.vue?vue&type=template&id=4d45e3ae"
import script from "./discussion-modal.vue?vue&type=script&lang=js"
export * from "./discussion-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__